module.exports = __webpack_public_path__ + "7f18571fa763d0e6d9974e8e29c002f5.pdf";